/**
 * ProgressEmptyState — shown when the domain has no audits yet.
 * Spec §4.6, visual ref 05-empty-state.html.
 */

export function ProgressEmptyState() {
  return (
    <div className="flex flex-col items-center justify-center py-20 gap-6 text-center">
      <div className="w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center">
        <svg className="w-8 h-8 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      </div>
      <div className="max-w-sm">
        <h3 className="text-lg font-semibold text-slate-900">No audit history yet</h3>
        <p className="text-sm text-slate-500 mt-2 leading-relaxed">
          Once your first audit completes, the Progress tab will show you how your SEO, AEO, and GEO
          scores improve over time — and link each improvement to the fix that caused it.
        </p>
      </div>
      <p className="text-xs text-slate-400">
        Go to the <span className="font-medium">Audits tab</span> and trigger an audit to get started.
      </p>
    </div>
  );
}
